/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { EllipsisTextStyled } from '../../../../../../components/common/EllipsisText/styled/EllipsisTextStyled';
import { ELinkTarget } from '../../../../../../components/common/ExternalLink/ExternalLink';
import { ONBOARDING_DATA_ATTR } from '../../../../../../modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '../../../../../../modules/onboarding/types/onboardingTypes';
import { colors } from '../../../../../../theme';
import { IAttrStyled } from '../../../../../../types/globalTypes';
import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';
import { WidgetListItem } from '../../styled/WidgetStyled';

export const WidgetSubscriberMaxCostsStyled = styled(WidgetBlockStyled).attrs({
    'data-widget': 'WidgetSubscriberMaxCosts',
    [ONBOARDING_DATA_ATTR]: EOnboardingComponentsId.widgetSubscriberMaxCosts,
})<IAttrStyled>`
    display: flex;
    flex-direction: column;
    min-height: 348px;

    &.widget__widget-max-costs__error,
    &.widget__widget-max-costs__empty {
        height: 392px;
    }
`;

export const WidgetSubscriberMaxCostsListItemStyled = styled(WidgetListItem)``;

export const WidgetSubscriberMaxCostsListItemPhoneStyled = styled.a.attrs({
    target: ELinkTarget.PARENT,
})`
    margin-bottom: 3px;
    text-decoration: none;
    color: ${colors.pageDashboardWidgetText};
`;

export const WidgetSubscriberMaxCostsListItemFioStyled = styled.span`
    color: ${colors.pageDashboardWidgetSecondaryText};
`;

export const WidgetSubscriberMaxCostsListSuccessStyled = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    line-height: 1.6;

    margin-bottom: 24px;
`;

export const WidgetSubscriberMaxCostsEmptyLabelStyled = styled.div`
    width: 100%;
    max-width: 270px;
    margin: 16px auto 4px;
    text-align: center;
`;

export const WidgetSubscriberMaxCostsEmptyLabelTipsStyled = styled.div`
    text-align: center;
    opacity: 0.5;
`;

export const WidgetSubscriberMaxCostsListItemLeftStyled = styled.div`
    display: flex;
    flex-direction: column;
    width: 65%;

    & ${EllipsisTextStyled} {
        width: 100%;
    }

    .subscriber-link {
        margin-bottom: 4px;
    }
`;

export const WidgetSubscriberMaxCostsListItemRightStyled = styled.div`
    width: 35%;
    text-align: right;
`;
